var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFillOwner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6AC89E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5292 7.22182L12.7478 7.57879L10.7451 5.57221C10.5477 5.37437 10.2796 5.26318 10.0001 5.26318C9.72058 5.26318 9.45253 5.37437 9.25506 5.57221L7.2524 7.57879L5.47101 7.22182C5.11496 7.15048 4.74729 7.26768 4.49822 7.53192C4.24915 7.79616 4.15385 8.17012 4.24609 8.52133L5.67232 13.9515C5.79382 14.4142 6.21204 14.7368 6.69041 14.7368H13.3098C13.7882 14.7368 14.2064 14.4142 14.3279 13.9515L15.7541 8.5213C15.8463 8.17009 15.751 7.79614 15.502 7.53192C15.2529 7.26769 14.8852 7.15048 14.5292 7.22182Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFillOwner);
export default ForwardRef;